import { render, staticRenderFns } from "./RecipeList.vue?vue&type=template&id=8bcbbf0a&"
import script from "./RecipeList.vue?vue&type=script&lang=js&"
export * from "./RecipeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports